import comp from "./DocumentCategoryHeader";
export default comp;
